import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="subject-field"
//
// Mirrors what the user types into the worked example underneath, so the effect
// of the subject is visible before an email goes out. Save state is not handled
// here — that is form-auto-save broadcasting to save-indicator, the same pair
// the survey builder uses.
export default class extends Controller {
  static targets = ["input", "example"];
  static values = { fallback: String, date: String };

  declare readonly inputTarget: HTMLInputElement;
  declare readonly exampleTarget: HTMLElement;
  declare fallbackValue: string;
  declare dateValue: string;

  // An empty field still sends — it falls back to the dashboard's name — so the
  // example shows that rather than an empty subject.
  preview() {
    const subject = this.inputTarget.value.trim() || this.fallbackValue;

    this.exampleTarget.textContent = `\u201C${subject} \u2014 ${this.dateValue}\u201D`;
  }
}
